import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from "../../Contexts/AuthContext";
import { globalServices } from "../../Services";
import logo from "../../Images/logo2.png";
import { useTranslation } from "react-i18next";

const SwitchTenant = () => {
  const { t: translator } = useTranslation();
  const { userId, setTenant, setTenantName, setUseAccounting } = useContext(
    AuthContext
  );
  const [switchTenant, setSwitchTenant] = useState([]);

  useEffect(() => {
    globalServices
      .getTenants(userId, "")
      .then((res) => {
        setSwitchTenant(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleSwitch = (id, name, useAccounting) => {
    setTenant(id);
    setTenantName(name);
    setUseAccounting(useAccounting);

    window.location.href = `/tenants/${id}`;
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <h3 style={{ marginTop: "10px" }} className="tile-h3">
            {translator("SwitchTenant-ChooseTenant")}
          </h3>
        </div>
        {switchTenant.map((i, key) => (
          <div className="col-lg-6 col-sm-4 col-xs-12" key={key}>
            <div className="custom-tile">
              <div className="custom-tile-title">
                <img src={i.logo ? i.logo : logo} />

                <h2>{i.name}</h2>
              </div>
              <div className="custom-tile-subtitle">{i.oib}</div>

              <button
                onClick={() => handleSwitch(i.id, i.name, i.useAccounting)}
                className="btn btn-primary btn-block custom-tile-button"
              >
                {translator("SwitchTenant-Continue")}
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
export default SwitchTenant;
